import { AppState } from './app.state';
import { Action, ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import {
  changeVisibilityOfBackendError,
  setMaintenanceModeEnabled,
  setVisibilityOfCustomerChat,
  setYouthHealthPackagesEnabled,
  setVisibilityOfAdvancedMedicSearch,
  setJevUnapprovedPremiumHintEnabled,
} from './app.actions';

export const initialAppState: AppState = {
  showBackendErrorPopup: false,
  showCustomerChat: false,
  showMaintenanceModeScreen: false,
  showYouthHealthPackages: false,
  showAdvancedMedicSearch: false,
  showJevUnapprovedPremiumHint: false,
};

export const generalAppReducers: ReducerTypes<AppState, ActionCreator[]>[] = [
  on(changeVisibilityOfBackendError, (appState, payload) => ({
    ...appState,
    showBackendErrorPopup: payload.showBackendErrorPopup,
  })),
  on(setVisibilityOfCustomerChat, (appState, payload) => ({
    ...appState,
    showCustomerChat: payload.showCustomerChat,
  })),
  on(setMaintenanceModeEnabled, (appState, payload) => ({
    ...appState,
    showMaintenanceModeScreen: payload.showMaintenanceModeScreen,
  })),
  on(setYouthHealthPackagesEnabled, (appState, payload) => ({
    ...appState,
    showYouthHealthPackages: payload.showYouthHealthPackages,
  })),
  on(setVisibilityOfAdvancedMedicSearch, (appState, payload) => ({
    ...appState,
    showAdvancedMedicSearch: payload.showAdvancedMedicSearch,
  })),
  on(setJevUnapprovedPremiumHintEnabled, (appState, payload) => ({
    ...appState,
    showJevUnapprovedPremiumHint: payload.showJevUnapprovedPremiumHint,
  })),
];

const appReducer = createReducer<AppState>(initialAppState, ...generalAppReducers);

export function reducer(state: AppState | undefined, action: Action): AppState {
  return appReducer(state, action);
}
